export enum ModuleNameEnum {
    users = "Utilisateurs",
    bymE = "Bym-E",
    aiAnalysis = "Analyse IA",
    activityReport = "Rapport Activité",
    aiPlanning = "Planning IA",
    aiProduct = "Produit IA",
    unlimitedPack = "Pack illimité",
}
